import { render, staticRenderFns } from "./FunItem.vue?vue&type=template&id=1db586c7&scoped=true"
import script from "./FunItem.vue?vue&type=script&lang=js"
export * from "./FunItem.vue?vue&type=script&lang=js"
import style0 from "./FunItem.vue?vue&type=style&index=0&id=1db586c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db586c7",
  null
  
)

export default component.exports